// extracted by mini-css-extract-plugin
module.exports = {"a":"styles_a__LQAmm"};